export default 'bottlebooks:wfsLocationKey';
